export const setContentNodes = (payload) => (dispatch) => {
  dispatch({
    type: 'SET_CONTENT_NODES',
    payload,
  });
};
